export default __webpack_public_path__ + "static/media/GrowthCalculation.c0bf7f31.png";